(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cm-fathers-day-quiz"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cm-fathers-day-quiz')) {
    class CMFathersDayQuiz extends HTMLElement {
      connectedCallback() {
        if (this.dataset.quizReady === 'true') return;

        this.dataset.quizReady = 'true';
        this.form = this.querySelector('[data-quiz-form]');
        this.quizBody = this.querySelector('[data-quiz-body]');
        this.questions = Array.from(this.querySelectorAll('[data-question]'));
        this.steps = Array.from(this.querySelectorAll('[data-step]'));
        this.progress = this.querySelector('[data-progress]');
        this.progressText = this.querySelector('[data-progress-text]');
        this.resultPanel = this.querySelector('[data-result-panel]');
        this.results = Array.from(this.querySelectorAll('[data-result]'));
        this.liveRegion = this.querySelector('[data-live-region]');
        this.current = 0;
        this.scores = { office: 0, adventure: 0, storyteller: 0, statement: 0, dreamer: 0 };
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.handleClick = this.onClick.bind(this);
        this.handleReset = this.onReset.bind(this);
        this.addEventListener('click', this.handleClick);
        this.form.addEventListener('reset', this.handleReset);
        this.renderQuestion(false);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        if (this.form) this.form.removeEventListener('reset', this.handleReset);
      }

      onClick(event) {
        const answer = event.target.closest('[data-answer]');
        if (!answer || !this.contains(answer)) return;

        const key = answer.dataset.answer;
        if (!Object.prototype.hasOwnProperty.call(this.scores, key)) return;

        this.runTransition(() => {
          this.scores[key] += 1;
          this.current += 1;

          if (this.current < this.questions.length) {
            this.renderQuestion(true);
          } else {
            this.showResult();
          }
        });
      }

      onReset(event) {
        event.preventDefault();
        this.runTransition(() => this.restart());
      }

      runTransition(update) {
        if (document.startViewTransition && !this.reducedMotion.matches) {
          document.startViewTransition(update);
        } else {
          update();
        }
      }

      renderQuestion(shouldFocus) {
        this.quizBody.hidden = false;
        this.resultPanel.hidden = true;

        this.questions.forEach((question, index) => {
          question.hidden = index !== this.current;
        });

        this.steps.forEach((step, index) => {
          step.classList.toggle('is-complete', index < this.current);
          step.classList.toggle('is-current', index === this.current);
        });

        const number = this.current + 1;
        this.progress.setAttribute('aria-valuenow', String(number));
        this.progressText.textContent = 'Question ' + number + ' of ' + this.questions.length;

        const activeQuestion = this.questions[this.current];
        const legend = activeQuestion.querySelector('legend');
        this.liveRegion.textContent = this.progressText.textContent + ': ' + legend.textContent;

        if (shouldFocus) requestAnimationFrame(() => legend.focus());
      }

      showResult() {
        const entries = Object.entries(this.scores);
        const winner = entries.reduce((best, current) => current[1] > best[1] ? current : best)[0];
        const winningResult = this.results.find((result) => result.dataset.result === winner);

        this.quizBody.hidden = true;
        this.resultPanel.hidden = false;
        this.results.forEach((result) => {
          result.hidden = result !== winningResult;
        });
        this.steps.forEach((step) => {
          step.classList.add('is-complete');
          step.classList.remove('is-current');
        });
        this.progress.setAttribute('aria-valuenow', String(this.questions.length));
        this.liveRegion.textContent = 'Quiz complete. Your result is ' + winningResult.querySelector('h3').textContent + '.';
        requestAnimationFrame(() => winningResult.querySelector('h3').focus());
      }

      restart() {
        this.current = 0;
        Object.keys(this.scores).forEach((key) => {
          this.scores[key] = 0;
        });
        this.results.forEach((result) => {
          result.hidden = true;
        });
        this.renderQuestion(true);
      }
    }

    customElements.define('cm-fathers-day-quiz', CMFathersDayQuiz);
  }

  } catch(e) { console.error(e); }
})();
})();
